module.exports = __webpack_public_path__ + "img/JBI_banner_rp.f1852358.png";